import React from "react";
import { Button, ButtonProps } from "@cmp-src/primitives/button";

export type ModalCancelButtonProps = ButtonProps;

export const ModalCancelButton: React.FC<ModalCancelButtonProps> = ({
  ...rest
}) => {
  return (
    <Button className="w-full sm:w-auto" variant="outline" {...rest} />
  );
};
